import { inject } from '@angular/core';
import { StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationSelectDay {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);

  routes = PublicRoutes;
  selectedGroup = this.stationsService.getSelectedGroup();
  selectedDate = this.stationsService.getSelectedDate();
  minDate = new Date();
  maxDate = new Date();
  disabledDates: Date[] = [];

  init() {
    if (this.selectedGroup) {
      this.setDisabledDates();
    }
  }

  setDisabledDates() {
    this.disabledDates = this.selectedGroup!.diabledDates;
    this.minDate = this.selectedGroup!.minDate;
    this.maxDate = this.selectedGroup!.maxDate;
  }

  onSelect(date: Date) {
    this.stationsService.setSelectedDate(date);
  }
}